import { rest } from "msw";
import { endpoints } from "@src/lib/http/useEndpointUrls";

export const getUserProfilesErrorHandler = rest.get(`${endpoints.GATEWAY}/userprofile`, (_, res, ctx) => {
  return res(ctx.status(500));
});
